module.exports = __webpack_public_path__ + "img/1557614079291498497.f6427080.png";